/**
 * Storage Key Factory
 * 集中管理所有 localStorage Key，避免拼寫錯誤並提供 TypeScript 型別安全
 */

/**
 * Storage Key 工廠函數
 * 所有 Key 都應該透過這個工廠產生，確保命名一致性
 */
export const STORAGE_KEYS = {
  /**
   * 表格欄位顯示狀態
   * @param page - 頁面名稱，例如 'admin_products', 'admin_orders'
   */
  TABLE_COLUMNS: (page: string) => `table_cols_${page}`,

  /**
   * 表格排序設定
   * @param page - 頁面名稱
   */
  TABLE_SORT: (page: string) => `table_sort_${page}`,

  /**
   * 表格篩選設定
   * @param page - 頁面名稱
   */
  TABLE_FILTERS: (page: string) => `table_filters_${page}`,

  /**
   * 表格分頁大小偏好
   */
  TABLE_PAGE_SIZE: () => 'table_pageSize',

  /**
   * POS 頁面商品分類篩選
   */
  POS_CATEGORY_FILTER: () => 'pos_category_filter',

  /**
   * POS 頁面商品類型篩選
   */
  POS_TYPE_FILTER: () => 'pos_type_filter',

  /**
   * POS 頁面搜尋關鍵字
   */
  POS_SEARCH_QUERY: () => 'pos_search_query',

  /**
   * POS 購物車備份（災難恢復用）
   */
  POS_CART_BACKUP: () => 'pos_cart_backup',

  /**
   * UI 側邊欄摺疊狀態（全域）
   */
  UI_SIDEBAR_COLLAPSED: () => 'ui_sidebar_collapsed',

  /**
   * UI 主題偏好（全域）
   */
  UI_THEME: () => 'ui_theme',

  /**
   * Admin 導航項目顯示狀態（全域）
   */
  ADMIN_NAV_VISIBILITY: () => 'admin_nav_visibility',

  /**
   * 搜尋歷史（tenant 隔離）
   */
  SEARCH_HISTORY: () => 'search_history',

  /**
   * 最近查看的商品（tenant 隔離）
   */
  RECENT_PRODUCTS: () => 'recent_products',

  /**
   * 最近查看的訂單（tenant 隔離）
   */
  RECENT_ORDERS: () => 'recent_orders',
} as const;

/**
 * 取得所有 Storage Key 的型別
 */
export type StorageKey = ReturnType<
  (typeof STORAGE_KEYS)[keyof typeof STORAGE_KEYS]
>;
